import React, { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { useDispatch, useSelector } from "react-redux";
import * as messagingManagementActions from "../actions/Management/messagingManagementsActions";

const ImageViewer = () => {
  const dispatch = useDispatch();
  const imageSet = useSelector(
    (state) => state.messagingManagement.messageImageOpenId
  );
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    if (imageSet) setPhotoIndex(imageSet.ids.indexOf(imageSet.current));
  }, [imageSet]);

  if (!imageSet) return null;
  const images = imageSet.ids;

  return (
    <Lightbox
      mainSrc={images[photoIndex]}
      nextSrc={images[(photoIndex + 1) % images.length]}
      prevSrc={images[(photoIndex + images.length - 1) % images.length]}
      clickOutsideToClose={false}
      onCloseRequest={() =>
        dispatch(messagingManagementActions.setImageOpen(undefined))
      }
      onMovePrevRequest={() =>
        setPhotoIndex((photoIndex + images.length - 1) % images.length)
      }
      onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
    />
  );
};

export default ImageViewer;
